var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ma-6 ml-9"},[_c('ScheduleSkeleton',{attrs:{"body-rows":10}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }